var React = require('react');

function ButtonSpinner (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"className":"spinner-circle","cx":"9","cy":"9","r":"8","stroke":"#333","strokeOpacity":".1","strokeWidth":"2","key":0}),React.createElement("path",{"className":"spinner-spline","stroke":"#FFF","strokeLinecap":"round","strokeWidth":"2","d":"M17 9a8 8 0 00-8-8","key":1})]));
}

ButtonSpinner.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = ButtonSpinner;

ButtonSpinner.default = ButtonSpinner;
